// extracted by mini-css-extract-plugin
module.exports = {"Breadcrumb":"breadcrumb_Breadcrumb__1gYyF","Active":"breadcrumb_Active__12wHf"};